import { Barangay, PrefixOption, Voter } from '../../types';
import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';

import { db } from '../../firebase';

interface PrecinctVotersListEntryProps {
  barangay: Barangay;
  precinct: string;
  prefixOption?: PrefixOption;
}

const PrecinctVotersListEntry: React.FC<PrecinctVotersListEntryProps> = ({ 
  barangay, 
  precinct,
  prefixOption = 'numbers'
}) => {
  const [voters, setVoters] = useState<Voter[]>([]);

  useEffect(() => {
    const fetchVoters = async () => {
      try {
        const votersCollection = collection(db, 'voters');
        const q = query(
          votersCollection, 
          where('barangay', '==', barangay.barangay),
          where('precinct', '==', precinct),
          orderBy('name', 'asc')
        );
        const votersSnapshot = await getDocs(q);
        const votersData = votersSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        } as Voter));
        setVoters(votersData);
      } catch (error) {
        console.error("Error fetching voters:", error);
      }
    };

    fetchVoters();
  }, [barangay, precinct]);

  const renderPrefix = (index: number) => {
    switch (prefixOption) {
      case 'numbers':
        return `${index + 1}. `;
      case 'bullets':
        return '• ';
      case 'none':
        return '';
      default:
        return `${index + 1}. `;
    }
  };

  return (
    <Box>
      {voters.map((voter, index) => (
        <Typography key={voter.id} variant="body2">
          {renderPrefix(index)}{voter.name}
        </Typography>
      ))}
    </Box>
  );
};

export default PrecinctVotersListEntry;
